// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"4fc1ce0d","787":"defb9b32","843":"35ebd6be","846":"b87372ef"}[chunkId] + ".chunk.js";
};